import { InjectionToken } from '@angular/core';
import { TokenApi } from './token-api.interface';

export const TOKEN_API = new InjectionToken<TokenApi>('TOKEN_API');